<template>
    <div class="heading-wrapper">
        <div
            class="page-content text-section flex-column d-flex justify-center"
        >
            <div class="text-group">
                <p v-if="$vuetify.breakpoint.lgAndDown" class="text-title">
                    CHECK YOUR CARD BALANCE
                </p>
                <p v-if="$vuetify.breakpoint.xlOnly" class="text-title">
                    CHECK
                </p>
                <p v-if="$vuetify.breakpoint.xlOnly" class="text-title">
                    YOUR CARD BALANCE
                </p>
                <p class="text-subtitle">
                    Enter the PIN to check your card's remaining balance.
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'page-heading',
};
</script>

<style lang="scss" scoped>
.heading-wrapper {
    width: 100%;
}
.text-section {
    text-align: center;
    margin-top: 71px;
    @include break('sm') {
        margin-top: 220px;
    }
    @include break('md') {
        margin-top: 139px;
    }
    @include break('lg') {
        margin-top: 132px;
    }
    @include break('xl') {
        text-align: left;
        margin-left: 205px;
        margin-top: 16px;
    }
    .text-group {
        color: #212843;
        .text-title {
            font-family: KlavikaNX-Medium, serif;
            font-size: 30px;
            line-height: 1.33;
            font-weight: bold;
            @include break('md') {
                font-size: 44px;
                line-height: 1.02;
                font-weight: 500;
            }
            @include break('lg') {
                font-size: 50px;
                line-height: 0.9;
            }
            @include break('xl') {
                font-size: 60px;
            }
            margin-bottom: 0;
        }
        .text-subtitle {
            padding-top: 12px;
            margin-bottom: 43px;
            font-size: 14px;
            line-height: 1.71;
            @include break('md') {
                padding-top: 16px;
                font-size: 16px;
                line-height: 2.19;
            }
            @include break('xl') {
                padding-top: 30px;
                font-size: 20px;
                line-height: 1.75;
            }
            color: #212843;
        }
    }
}
</style>
